<template>
  
</template>
<script>
export default {
  data(){
    return{
    }
  },
  mounted:function(){
    this.goPage()
  },
  methods:{
    goPage:function(url){
      this.$router.push("/login")
    },
  },
}
</script>

<style>
  .User-index-page{

  }
  
    .banner-box{
        width:100%;
        height: 300px;
    }

    .courses {
        overflow: hidden;
    }
    .course{
        width: 25%;
        text-decoration: none;
        margin: 10px 0;
        float:left;
    }
    .course-box:active,
    .course-box:hover {
        box-shadow: 0 3px 8px 0 #eee
    }

    .course-box {
        display: block;
        position: relative;
        min-height: 220px;
        margin: 0;
        background: #fff;
        box-shadow: 0 2px 2px 0 #eee;
        margin-left: 15px;
        margin-right: 15px;
    }

    .course-box .sign-box {
        width: 100%;
        color: #565a61;
        padding: 0 5%;
        position: absolute;
        z-index: 9;
        top: -5px
    }

    .course-box .sign-box .course-new {
        margin-right: 5px
    }

    .course-box .sign-box .course-follow {
        display: none;
        color: #f35e69;
        font-size: 18px;
        margin-top: 15px
    }

    .course-box .course-img {
        width: 100%
    }

    .course-box .course-img>img {
        width: 100%;
        height: 240px
    }

    .course-box .course-progress-bar {
        width: 100%;
        height: 5px;
        background-color: #eee
    }

    .course-box .course-progress-bar>div {
        background-color: #5ac65a;
        box-shadow: none
    }

    .course-box .course-body {
        padding: 5% 5% 0
    }

    .course-box .course-body .course-title {
        display: inline-block;
        width: 100%;
        color: #4c5157;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
    }

    .course-box .course-body:after {
        content: "";
        display: block;
        clear: both
    }

    .course-box .course-footer {
        height: 43px;
        color: #9b9da2;
        padding: 10px 5%;
        overflow: hidden
    }

    .course-box .course-footer .course-per-num {
        display: inline-block;
        padding: 4px 0 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center
    }

    .course-box .course-footer .course-bootcamp {
        padding: 3px 10px;
        color: #fff;
        border-radius: 100px;
        background-color: #f66e6e
    }

    .course-box .course-footer .course-money {
        padding: 3px 10px;
        color: #fff;
        border-radius: 100px;
        background-color: #ffae0f
    }

    .course-box .course-footer .course-free {
        padding: 3px 10px;
        color: #fff;
        border-radius: 100px;
        background-color: #59cf4a
    }

    .course-box .course-footer:after {
        content: "";
        display: block;
        clear: both
    }
  .User-ddd-page  .float-right{
      float:right;
    }


  .User-ddd-page .notice-head{
    width:1140px;
    margin:0 auto;
    font-size:16px;
    background:#e1e0ff;
    padding:0 5px;
    line-height:50px;
  }
  .User-ddd-page .notice{
    overflow:hidden;
    display:block;
    padding:25px 0 5px;
  }
  .User-ddd-page .notice .notice-box{
    overflow:hidden;
    display:block;
    padding:10px 0;
    border-bottom:1px dotted #ccc;
  }
  .User-ddd-page .notice .notice-box .notice-body{
    float:left;
    color:black;
    font-size:14px;
  }
  .User-ddd-page .notice .notice-box .notice-footer{
    float:right;
    color:black;
    font-size:12px;
  }
</style>

